import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import useBreakpoint from '@/composables/useBreakpoint'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { UserModule } from '@/store/modules/user'

  interface FooterLink {
    href: string
    text: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

  const { isSmallerMobileDevice } = useBreakpoint()
  const { inDevelopment, windowOpenProxyCheck, is34ACompany } = useCommonMixin()

  const companyDomainName = computed(() => UserModule.company?.domainName)

  const footerLinks = computed<FooterLink[]>(() => {
    const baseDomain = is34ACompany ? `https://www.${companyDomainName.value}` : 'https://www.sachkundegurus.de'

    return [
      { href: `${baseDomain}/impressum`, text: 'Impressum' },
      { href: `${baseDomain}/datenschutz`, text: 'Datenschutz' },
      { href: `${baseDomain}/agb`, text: 'AGB' },
    ]
  })

  const goToCompanyDomain = () => {
    windowOpenProxyCheck(`https://www.${companyDomainName.value}`, '_blank', 'company_website')
  }

return { __sfc: true,isSmallerMobileDevice, inDevelopment, windowOpenProxyCheck, is34ACompany, companyDomainName, footerLinks, goToCompanyDomain, computed, useBreakpoint, useCommonMixin, UserModule }
}

})